<template>
  <div ref="container" class="fachords_app">

    <div class="appPanel rounded" :style="giancaRemoveBackground === true ? { backgroundColor: 'white!important' } : {}">

      <!-- loader lessons -->
      <div v-if="1 === 2">
        <div class="centered">
          <img src="/static/fachords3/tools/media/loading.gif" alt="loading app">
          <p><i>Loading your interactive tool</i></p>
        </div>
      </div>


      <!-- lessons loaded, si parte! -->
      <div v-else>


        <!-- info panel -->
        <div v-show="showInfo===true">
          <h3 class="appTitle">About This tool</h3>

          <p>This interactive tool has been created by <a href="https://www.fachords.com" target="_blank">FaChords Guitar</a>, to help guitar students improve their skills in an intuitive way.</p>


          <p>For any request, you can <a href="https://www.fachords.com" target="_blank">contact us here</a>.

          <p><a @click="showInfo=false" style="cursor: pointer">Back to the tool</a></p>
        </div>

        <!-- tool -->
        <div v-show="showInfo===false">

          <div class="row">
            <div class="col-8 col-xm-24 col-lg-8 col-sm-8 sm-padding">
              <h3>Chords</h3>
              <div class="select-wrapper">
                <select class="form-control" v-model="selected_chord_root_id" style="width: 50px!important;">
                  <option v-for="option in chord_roots" :value="option.value" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <select class="form-control" v-model="selected_chord_type">
                  <option v-for="option in chord_types" :value="option" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-8 col-xm-24 col-lg-8 col-sm-8 sm-padding">
              <h3>Scales</h3>
              <div class="select-wrapper">
                <select class="form-control" v-model="selected_scale_root_id" style="width: 50px!important;">
                  <option v-for="option in scale_roots" :value="option.value" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <select class="form-control" v-model="selected_scale_type">
                  <option v-for="option in scale_types" :value="option" :key="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-8 col-xm-24 col-lg-8 col-sm-8 sm-padding">
              <h3>Controls</h3>
              <button class="btn rounded btn-primary" v-show="showTones===true" @click="toggleTones()">Show notes</button>
              <button class="btn rounded btn-primary" v-show="showTones===false" @click="toggleTones()">Show tones</button>
            </div>

          </div>

          <FretboardContainer :guitar="guitar"
                              :showTones="showTones"
                              @fretClick="handleFretClick"/>


        </div>






            <Structure :data="convertDataToDict(chord_data)" :isScale="false" :offset="selectChordRootStep" :showTones="showTones" :header="completeChordName"/>

            <!-- scale formula -->

            <Structure :data="convertDataToDict(scale_data)" :isScale="true" :offset="selectChordRootStep" :showTones="showTones" :header="completeScaleName"/>
          </div>





    </div>


  </div>

</template>


<script>

import FretboardContainer from "@shared/components/fretboard/FretboardContainer";
import Structure from "@shared/components/Structure";
import appStore from "./appStore"
import baseStore from "@shared/stores/baseStore";
import {debounce} from "@shared/helpers/utils";
import {KEYS} from "@shared/helpers/mappings"
// eslint-disable-next-line no-unused-vars
import {CHORD_TYPES} from "@shared/helpers/mappings"
// eslint-disable-next-line no-unused-vars
import {SCALE_TYPES} from "@shared/helpers/mappings"

export default {
  components: {FretboardContainer, Structure},

  data() {
    return {
      showInfo: false, giancaRemoveBackground: false, showTones: false, isPlay: false,

      debounceBpmTimer: null,

      selected_chord_root_id: 0, chord_roots: [{text: 'C', value: 0}, {text: 'D', value: 2}, {text: 'E', value: 4}],

      selected_chord_type: null, // This will hold the value of the selected option
      chord_types: [ // Array of objects for each option
        {text: 'Major', value: 0, tones: ['1', '3', '5']}, {text: 'Minor', value: 1, tones: ['1', 'b3', '5']}, {text: 'Dominant  7th', value: 2, tones: ['1', '3', '5', 'b7']}
        // Add more options as needed
      ],

      selected_scale_root_id: 0, scale_roots: [{text: 'C', value: 0}, {text: 'D', value: 2}, {text: 'E', value: 4}

      ],

      selected_scale_type: null,

      scale_types: [ // Array of objects for each option
        {text: 'Major scale', value: 0, tones: ['1', '2', '3', '4', '5', '6', '7']}, {text: 'Mixolydian scale', value: 2, tones: ['1', '2', '3', '4', '5', '6', 'b7']},
        {text: 'Minor scale', value: 1, tones: ['1', '2', 'b3', '4', '5', '6', '7']}

      ]

    };
  },


  watch: {
    // eslint-disable-next-line no-unused-vars
    selected_chord_root_id(newValue, oldValue) {
      this.setChordAndScale();
    }, // eslint-disable-next-line no-unused-vars
    selected_chord_type(newValue, oldValue) {
      this.setChordAndScale();
    }, // eslint-disable-next-line no-unused-vars
    selected_scale_root_id(newValue, oldValue) {
      this.setChordAndScale();
    }, // eslint-disable-next-line no-unused-vars
    selected_scale_type(newValue, oldValue) {
      this.setChordAndScale();
    }
  },


  created() {
    //abilita modifiche sequenza da utente
    baseStore.commit('setEnableUserInput', {'value': true});
  },


  computed: {

    guitar() {
      return baseStore.state.guitar;
    },

    soundLoaded() {
      return baseStore.getters.soundLoaded;
    },

    bpm() {
      return baseStore.state.soundTrack.bpm;
    },

    chord_data() {
      return appStore.getters.chord_data;
    },

    scale_data() {
      return appStore.getters.scale_data;
    },

    selectChordRootStep() {
      let rootName = this.chord_roots[this.selected_chord_root_id].text;
      return KEYS[rootName].step;
    },

    completeChordName() {
      let name = this.chord_roots[this.selected_chord_root_id].text;
      if (this.selected_chord_type !== null) {
        name = name + ' ' + this.selected_chord_type.text;
      }
      return name;

    },

    completeScaleName() {
      let name = this.chord_roots[this.selected_scale_root_id].text;
      if (this.selected_scale_type !== null) {
        name = name + ' ' + this.selected_scale_type.text;
      }
      return name;
    },


    localBpm: {
      get() {
        return this.bpm
      }, set(value) {
        if (this.debounceBpmTimer) clearTimeout(this.debounceBpmTimer)
        this.debounceBpmTimer = setTimeout(() => {
          baseStore.dispatch('setBpm', {'bpm': value})
        }, 500)
      },
    },

  },


  mounted() {


    window.addEventListener('keydown', this.handleKeyPress);

    let i = 0;
    this.chord_roots = [];
    this.scale_roots = []
    for (const key in KEYS) {
      this.chord_roots.push({'value': i, 'notes': KEYS[key].notes, 'text': key, 'step': KEYS[key].step})
      this.scale_roots.push({'value': i, 'notes': KEYS[key].notes, 'text': key, 'step': KEYS[key].step})
      i++;
    }

    i = 0;
    this.scale_types = [];
    for (const key in SCALE_TYPES) {
      this.scale_types.push({'value': i, 'tones': SCALE_TYPES[key].tones, 'text': key});
      i++;
    }

    i = 0;
    this.chord_types = [];
    for (const key in CHORD_TYPES) {
      this.chord_types.push({'value': i, 'tones': CHORD_TYPES[key].tones, 'text': key});
      i++;
    }

  },


  methods: {

    setChordAndScale() {

      let chord_root = this.chord_roots[this.selected_chord_root_id].text;
      let scale_root = this.scale_roots[this.selected_scale_root_id].text;
      let chord_tones = null;
      let scale_tones = null;

      if (this.selected_chord_type !== null) {
        chord_tones = this.selected_chord_type.tones;
      }


      if (this.selected_scale_type !== null) {
        scale_tones = this.selected_scale_type.tones;
      }


      appStore.commit('setChordAndScale', {
        'chord_root': chord_root, 'chord_tones': chord_tones, 'scale_root': scale_root, 'scale_tones': scale_tones
      })
    },


    onChangeBpmDebounced: debounce(function (event) {
      baseStore.dispatch('setBpm', {'bpm': event.target.value})

    }, 300), // Adjust the delay as needed (e.g., 300ms)


    convertDataToDict(data) {

      if (data === null) {
        return {}
      }

      let my_dict = {};

      for (let i = 0; i < data.length; i++) {
        let step = data[i].step;
        my_dict[step] = data[i];
      }
      return my_dict;
    },


    handleFretClick(params) {
      baseStore.commit('toggleFret', params)
    },

    handleKeyPress(event) {

      if (event.key === 'B') {
        // Toggle the value of isTrue

        this.giancaRemoveBackground = !this.giancaRemoveBackground;
      }
    },

    beforeDestroy() {

      window.removeEventListener('keydown', this.handleKeyPress);
    },


    rewind() {
      baseStore.commit('rewind')
    },

    togglePlay() {
      this.isPlay = !this.isPlay;

      if (this.isPlay === true) {
        baseStore.commit('startPlayback')
      } else {
        baseStore.commit('stopPlayback')
      }
    },

    toggleTones() {
      this.showTones = !this.showTones;
    },


  }
}

</script>

<style>


.select-wrapper {
  display: flex; /* Use flexbox layout */
  align-items: flex-start; /* Align items vertically in the center, if needed */
  justify-content: flex-start; /* Align items to the start of the flex container */
  gap: 0; /* Optional: adds space between the select elements */
}


.fachords_app {
  background-color: #FFFFFF;
}

@media only screen and (max-width: 600px) {
  .fachords_app {
    height: 1100px;
  }

  .appControl {
    margin-bottom: 5px;
  }
}

@media only screen and (min-width: 600px) {
  .fachords_app {
    height: 600px;
  }
}


appTitle {
  color: #222222;
}

.appPanel {
  background-color: #f2f2f3;

  padding: 1em;
  overflow: auto;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: content-box;
  box-sizing: border-box;
  height: 100%;
}


.hud {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.appSelectList {
  height: 35px; /* Adjust the height as needed */
  margin-right: 1px;
  padding-left: 5px;
  min-width: 150px;
  background-color: white;
  width: 40%;
}

.bpmControl {
  width: 70px;
  text-align: center;
  margin-left: 1px;
  margin-right: 1px;
}

.appInput {
  height: 35px;
  margin-left: 1px;
  margin-right: 1px;

}

.appButton {
  height: 35px; /* Adjust the height as needed */
  padding: 0 15px;
  color: #222;
  background-color: #fcfcfc;
  border: 1px solid #222222;

  cursor: pointer;
  margin-left: 1px;
  margin-right: 1px;
  width: 50px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
}

.appIcon {
  width: 24px; /* Adjust the width and height to fit your icon */
  height: 24px;
  fill: #fff; /* Fill color for the SVG icon */

}

.appButton:hover {
  background-color: #cecece
}


.fret {
  position: absolute;
  height: 35px;
  float: left;
  cursor: pointer;
  text-align: center;
  z-index: 5;

}

.fretIsPlaying {
  background-color: white !important;
}


/*color gradi 0-11*/
.color_degree_0 {
  background-color: #F7E721;
  color: #222222 !important;
}

.color_degree_1 {
  background-color: #C6DF31;
  color: #FFFFFF;
}

.color_degree_2 {
  background-color: #6BBE52;
  color: #FFFFFF;
}

.color_degree_3 {
  background-color: #00AE84;
  color: #FFFFFF;
}

.color_degree_4 {
  background-color: #00AECE;
  color: #FFFFFF;
}

.color_degree_5 {
  background-color: #0086CE;
  color: #FFFFFF;
}

.color_degree_6 {
  background-color: #4261AD;
  color: #FFFFFF;
}

.color_degree_7 {
  background-color: #8C499C;
  color: #FFFFFF;
}

.color_degree_8 {
  background-color: #E7288C;
  color: #FFFFFF;
}

.color_degree_9 {
  background-color: #EF4142;
  color: #FFFFFF;
}

.color_degree_10 {
  background-color: #F76929;
  color: #FFFFFF;
}

.color_degree_11 {
  background-color: #FFAE21;
  color: #FFFFFF;

}

.fretMarker {

  position: absolute;
  width: 15px !important;
  height: 15px !important;
  background-color: #a2a2a2;
  text-align: center;


  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;

  margin-top: -5px;

  z-index: 0;


}


.fretboardWood {
  background-image: url("/static/fachords3/tools/media/maple.jpg");
  background-repeat: repeat;

}

.note {
  color: #222222;
  background-color: #FEFEFE;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  pointer-events: none;


  font-size: 18px;

  overflow: hidden;
  white-space: nowrap;

  z-index: 5;

  height: 23px;
  width: 55px;
  min-width: 55px;
  box-shadow: 5px 5px 10px black;
}

.isHovering {
  background-color: yellow;
}

.about_link {
  display: block;
  margin: 0;
  margin-bottom: -5px !important;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  color: #222;
  padding: 0px;
  font-weight: normal;
  transition: background-color 0.3s;
  line-height: 1.1;
}

.helpButton {
  position: relative;
  top: 0px;
  float: right;

}

.description {
  height: 80px;
  background-color: #fcfcfc;
  padding: 5px;
  text-align: center;
  line-height: 1.5em;
}

</style>
